import { Button, Modal } from 'react-bootstrap';
import EmptyStartIcon from '@/assets/icon-star-outline.svg?react';
import FilledStarIcon from '@/assets/icon-star-filled.svg?react';
import { useState } from 'react';
import useElysiaStore from '@/app/elysia-store';
import { getAiApp, updateAppRating } from '@/services/aiApps';
import notify from '@/services/notify';

const RatingAppModal = ({ setShowAppRateModal, showModal, singleAppData, setSingleCardData }) => {
  const MAX_RATING = 5;
  const ratingRange = Array.from({ length: MAX_RATING }, (_, i) => i + 1);
  const chatSessionId = useElysiaStore((state) => state.chatSessionId);
  const [userRating, setUserRating] = useState(singleAppData?.user_rating);
  const isSubmitDisabled = userRating === singleAppData?.user_rating;

  const handleSubmitRating = async () => {
    try {
      const response = await updateAppRating({
        session_id: chatSessionId,
        rating: userRating,
        agent_id: singleAppData.agent_id,
      });
      if (response?.data?.status) {
        notify({
          message: response?.data?.message,
          type: 'success',
        });
      }

      setShowAppRateModal(false);

      const updatedAppData = await getAiApp(singleAppData.agent_id);
      setSingleCardData(updatedAppData);
    } catch (error) {
      console.error('Failed to submit rating:', error);
    }
  };

  const handleRating = (rating: number) => {
    setUserRating(rating);
  };

  const getStarStatus = (starIndex: number) => {
    return userRating >= starIndex ? 'filled' : 'empty';
  };

  return (
    <>
      <Modal
        dialogClassName="elysia-modal rate-app-dialog"
        show={showModal}
        onHide={() => setShowAppRateModal(false)}
        centered
      >
        <Modal.Header className="border-0 pb-1" closeButton>
          <Modal.Title>Rate App </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-2">
          <div className="mt-1">
            {singleAppData?.user_rating == 0
              ? 'Apply a rating for the App. Your feedback helps us to improve your experience.'
              : 'Modify your App rating. Your feedback helps us to improve your experience.'}
          </div>
          <div className="d-flex gap-4 mt-2" aria-label="Rating options">
            {ratingRange.map((ele) =>
              getStarStatus(ele) === 'filled' ? (
                <FilledStarIcon
                  key={ele}
                  className="app-rating-icon my-3 cursor-pointer"
                  onClick={() => handleRating(ele)}
                />
              ) : (
                <EmptyStartIcon
                  key={ele}
                  className="app-rating-icon-empty my-3 cursor-pointer"
                  onClick={() => handleRating(ele)}
                />
              )
            )}
          </div>
        </Modal.Body>

        <Modal.Footer className="justify-content-between border-0 pt-3">
          <hr className="w-100 mb-3" />
          <Button onClick={() => setShowAppRateModal(false)} variant="secondary">
            Cancel
          </Button>
          <Button disabled={isSubmitDisabled} onClick={handleSubmitRating}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RatingAppModal;
